import { render, staticRenderFns } from "./salaryReceipt.vue?vue&type=template&id=f65f2c06&"
import script from "./salaryReceipt.vue?vue&type=script&lang=js&"
export * from "./salaryReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports